import $ from 'jquery';

const DISABLE_CLICK_CLASS = 'disable-row-click';

export default () => {
  $('.ui.table.selectable').each((_, element) => {
    const $table = $(element);
    const $rows = $table.find('tr[data-url]');

    $rows.css('cursor', 'pointer');
    $rows.find(`td.${DISABLE_CLICK_CLASS}`).css('cursor', 'default');

    // Add click event
    $rows.on('click', event => {
      if (notClickable(event)) {
        return;
      }

      const $row = $(event.currentTarget);
      const url = $row.attr('data-url');
      if (url && url.length) {
        // Redirecting to target page
        window.location.assign(url);
      }
    });
  });
};

function notClickable(event) {
  const $target = $(event.target);

  return (
    event.target.localName === 'a' ||
    event.target.localName === 'button' ||
    event.target.localName === 'i' ||
    $target.hasClass(DISABLE_CLICK_CLASS) ||
    $target.closest('td').hasClass(DISABLE_CLICK_CLASS)
  );
}



// WEBPACK FOOTER //
// ./src/plugins/table-row.js